<template>
  <v-form v-model="valid" ref="form">
    <v-row>
      <v-col :cols="inputColumns" class="pb-0">
        <v-text-field
          v-model="formData.name"
          outlined
          dense
          label="* Project name"
          :rules="[formRules.required]"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="py-0">
        <v-textarea
          v-model="formData.description"
          outlined
          dense
          label="Description"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="inputColumns" class="pt-0">
        <v-text-field
          v-model="formData.wiki"
          outlined
          dense
          label="Wiki link"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="inputColumns" class="pt-0">
        <v-select
          v-model="formData.customer_id"
          outlined
          dense
          label="Customer"
          :items="customers"
          item-value="id"
          item-text="name"
          :rules="[formRules.required]"
        ></v-select>
      </v-col>
    </v-row>

    <v-divider class="pb-4"></v-divider>

    <v-row>
      <v-spacer></v-spacer>

      <v-col cols="auto">
        <slot name="buttons-before"></slot>

        <v-btn depressed color="primary" @click="submit" :disabled="!valid"
          >Save</v-btn
        >

        <slot name="buttons-after"></slot>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ProjectCreateEditForm',
  data: () => ({
    valid: false,
    formData: {
      id: null,
      name: '',
      description: '',
      wiki: '',
      customer_id: null
    },
    formRules: {
      required: v => !!v || 'This field is required.'
    }
  }),
  computed: {
    ...mapGetters('projects', ['project']),
    ...mapGetters('customers', ['customers']),
    inputColumns() {
      return this.formData.id ? 6 : 12
    }
  },
  methods: {
    ...mapActions('projects', ['storeProject', 'updateProject']),
    ...mapActions('customers', ['fetchCustomers']),
    setFormData() {
      this.formData.id = this.project.id
      this.formData.name = this.project.name
      this.formData.description = this.project.description
      this.formData.wiki = this.project.wiki
      this.formData.customer_id = this.project.customer_id
    },
    submit() {
      console.log(this.formData)
      if (this.formData.id) {
        this.updateProject(this.formData)
      } else {
        this.storeProject(this.formData)

        this.$refs.form.reset()
      }

      this.$emit('submitted')
    }
  },
  mounted() {
    if (this.$route.params.project_id) {
      this.setFormData()
    } else {
      this.$refs.form.reset()
    }

    if (!this.customers || !this.customers.length) {
      this.fetchCustomers()
    }
  }
}
</script>
